import React from "react";
import Api from "../../services/api";
import TopBar from "../../Components/topBar/topBar";
import TextField from "../../Components/textField/textField";
import Button from "../../Components/commonButton/commonButton";
import Alert from "../../Components/alert/Alert";
import BottomBar from "../../Components/bottomBar/bottomBar";
import Select from "../../Components/select/select";
import HeaderForms from "../../Components/headerForms/HeaderForms";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import "./userPreference.css";

export default class UserAlterPassword extends React.Component {


  render() {
    const { show, message, email,shifts,selectedID } = this.state;

    return (
      <>
        <main className="user-preference-main">
          <div className="UserPreference-container">
          <HeaderForms text="Alterar senha" icon={faInfoCircle}/>
            {show ? (
              <Alert
                show={show}
                message={message}
                parentCallback={this.callbackfunction}
              />
            ) : null}
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              <form encType="multipart/form-data"  >
                <div>
                  <TextField
                    title="Nova senha"
                    typeValue="text"
                    value={this.state.username}
                    altType={true}
                    maxLength={20}
                    parentCallback={this.callBackUser}
                  />
                </div>
                <div>
                  <TextField
                    title="Confirmar nova senha"
                    typeValue="text"
                    value={this.state.username}
                    altType={true}
                    maxLength={20}
                    parentCallback={this.callBackUser}
                  />
                </div>
                <div>
                <Select autoSelect={true} 
                  selectedID={selectedID} 
                  label="Turno" 
                  handleSelect={this.handleSelectShift} 
                  arrData={shifts} 
                />
                </div>
                <div>
                  <TextField
                    title="Email"
                    typeValue="email"
                    value={email}
                    altType={true}
                    maxLength={30}
                    parentCallback={this.callBackEmail}
                  />
                </div>
                {/* <div>
              <TextField
                title="Nova senha"
                typeValue={"password"}
                maxLength={60}
                parentCallback={this.callBackPassword}
              />
            </div>
            <div>
              <TextField
                title="Confirme a senha"
                typeValue="password"
                maxLength={60}
                parentCallback={this.callBackConfirmPassword}
              />
            </div> */}
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{ fontWeight: 'bold' }} for="image">Logo da empresa:</label>
                  <input id={'image'} type="file" onChange={this.onFileChange} accept=".jpg, .jpeg, .png"></input>
                </div>
                <Button title="Salvar dados" parentCallback={this.sendData} />
              </form>
            </div>
          </div>
        </main>
        <BottomBar></BottomBar>
      </>
    );
  }
}